import { Play, Download, LogOut } from "lucide-react";
import { Footer } from "../component/Footer";
import logoApp from "../../../assets/images/Rocky/LOGOROCKY.png"
import { useNavigate } from "react-router-dom";
import { useAutoLogout } from "../../../utils/hooks/autoLogout";

const MainUptc = () => {
    const myNavigate = useNavigate();
    const handleLogout = () => {
        localStorage.removeItem("accessUptc");
        myNavigate("/");
    };
    useAutoLogout(1 * 60 * 1000); 
    return (
        <div className="min-vh-100" style={{ backgroundColor: "#f8f9fb" }}>

            {/* Hero */}
            <section style={{ backgroundColor: "#003366" }} className="text-white py-1 px-1 position-relative">


                <button
                    onClick={handleLogout}
                    className="btn btn-sm position-absolute"
                    style={{
                        top: 10,
                        right: 20,
                        backgroundColor: "transparent",
                        border: "1px solid rgba(255,255,255,0.4)",
                        color: "#fff",
                        borderRadius: "8px",
                        padding: "4px 12px"
                    }}
                    onMouseEnter={e => {
                        e.currentTarget.style.backgroundColor = "#dabf5c";
                        e.currentTarget.style.color = "#003366";
                    }}
                    onMouseLeave={e => {
                        e.currentTarget.style.backgroundColor = "transparent";
                        e.currentTarget.style.color = "#dabf5c";
                    }}
                >
Cerrar sesión
                </button>

                <div className="container" style={{ maxWidth: 600 }}>
                    <div className="text-center d-flex align-items-center justify-content-center gap-3 py-3">
                        <img src={logoApp} alt="" width={80} height={80} />

                        <div>
                            <h1
                                className="m-0 fw-bold"
                                style={{
                                    fontSize: "clamp(2rem, 5vw, 3rem)",
                                    fontFamily: "Montserrat, sans-serif"
                                }}
                            >
                                Rocky SAS
                            </h1>

                            <p className="m-0 small">
                                Sistema de información en atención primaria S.A.S
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <div className="container py-2" style={{ maxWidth: 1200 }}>

                <h2 className="fw-bold mb-4 d-flex align-items-center justify-center gap-2">
                    <Play size={22} color="#003366" />
                    Video de tutorial y link de descarga
                </h2>
                <div className="row g-4">
                    <div className="col-12 col-md-8">
                        <div
                            className="rounded-3 overflow-hidden shadow-sm"
                            style={{ position: "relative", paddingBottom: "56.25%" }}
                        >
                            <iframe
                                style={{
                                    position: "absolute",
                                    inset: 0,
                                    width: "100%",
                                    height: "100%",
                                    border: "none"
                                }}
                                src="https://www.youtube.com/embed/p64_xDDmGAo?si=hUZ-t91lTJ0PgHUh"
                                title="Video institucional"
                                allowFullScreen
                            />
                        </div>
                    </div>

                    <div className="col-12 col-md-4 d-flex flex-column gap-4">
                        {/* Card 1 */}
                        <div
                            className="p-4 bg-white rounded-4 border text-center"
                            style={{
                                transition: "all 0.2s ease",
                                cursor: "pointer"
                            }}
                            onMouseEnter={e => {
                                e.currentTarget.style.transform = "translateY(-4px)";
                                e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.08)";
                            }}
                            onMouseLeave={e => {
                                e.currentTarget.style.transform = "translateY(0)";
                                e.currentTarget.style.boxShadow = "none";
                            }}
                        >
                            <div className="mb-3">
                                <div
                                    className="d-flex align-items-center justify-content-center mx-auto mb-2"
                                    style={{
                                        width: 50,
                                        height: 50,
                                        borderRadius: "12px",
                                        backgroundColor: "#f5f7fa"
                                    }}
                                >
                                    <Download size={22} color="#003366" />
                                </div>

                                <h6 className="fw-medium mb-1 fw-bolder">Instalador</h6>
                                <p className="text-muted small mb-3">
                                    Archivo para instalar el sistema
                                </p>
                            </div>

                            <a
                                href="https://drive.google.com/file/d/1xRdtwF2rP3jLzeut8G5Y3K-2zsmmuhsg/view?usp=sharing"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm w-100"
                                style={{
                                    backgroundColor: "#1d6fd6",
                                    color: "#fff",
                                    borderRadius: "10px"
                                }}
                            >
                                Descargar
                            </a>
                        </div>

                        {/* Card 2 */}
                        <div
                            className="p-4 bg-white rounded-4 border text-center"
                            style={{
                                transition: "all 0.2s ease",
                                cursor: "pointer"
                            }}
                            onMouseEnter={e => {
                                e.currentTarget.style.transform = "translateY(-4px)";
                                e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.08)";
                            }}
                            onMouseLeave={e => {
                                e.currentTarget.style.transform = "translateY(0)";
                                e.currentTarget.style.boxShadow = "none";
                            }}
                        >
                            <div className="mb-3">
                                <div
                                    className="d-flex align-items-center justify-content-center mx-auto mb-2"
                                    style={{
                                        width: 50,
                                        height: 50,
                                        borderRadius: "12px",
                                        backgroundColor: "#f5f7fa"
                                    }}
                                >
                                    <Download size={22} color="#003366" />
                                </div>

                                <h6 className="fw-medium mb-1 fw-bolder">Rocky UPTC</h6>
                                <p className="text-muted small mb-3">
                                    Aplicación institucional
                                </p>
                            </div>

                            <a
                                href="https://drive.google.com/file/d/1xRdtwF2rP3jLzeut8G5Y3K-2zsmmuhsg/view?usp=sharing"
                                className="btn btn-sm w-100"
                                style={{
                                    backgroundColor: "#e9ecef",
                                    color: "#333",
                                    borderRadius: "10px"
                                }}
                            >
                                Descargar
                            </a>
                        </div>

                    </div>

                </div>
            </div>
            <Footer />

        </div>
    );
};

export default MainUptc;